/** Splits free-form address text on whitespace, commas and semicolons, dropping blanks. */
export const splitEmailEntries = (text: string): string[] =>
  text.split(/[\s,;]+/).filter((entry) => entry !== '')
